import { Table, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutCarrierScacLookup } from "./autogen/AutogenLayoutCarrierScacLookup";

export class CarrierScacLookup extends AutogenLayoutCarrierScacLookup {

    override async onLoad(): Promise<void> {
        const tableCarrierScac: Table = this.tableCarrierScac;
        tableCarrierScac.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            if (tableRow.index > 0) {
                tableRow.table.rows[tableRow.index - 1].borderBottomWidth = 1;
            }
        });
    }
}
